<template>
  <div class="hotel_detail_inner">
    <div class="bloc">
      <div class="pic">
        <img :src="require(`@/assets/img/${image01}`)" alt="" class="p1" />
        <img :src="require(`@/assets/img/${image02}`)" alt="" class="p2" />
        <img :src="require(`@/assets/img/${image03}`)" alt="" class="p3" />
      </div>
    </div>
    <div class="bloc right">
      <div class="area">{{ area }}</div>
      <div class="name">{{ name }}</div>
      <div class="en">{{ subName }}</div>
      <div
        v-for="(item, i) in catchTxt"
        :key="i"
        class="catch"
      >
        {{ item }}
      </div>
      <div class="code">
        <span class="subtitle"></span>旅：No.{{ puroductNo }}
      </div>
      <div class="privilege" v-if="privilege.length > 0">
        <h3>特典</h3>
        <ol>
          <li
            v-for="(item, i) in privilege"
            :key="i"
            class="newline"
          >
            {{ item }}
          </li>
        </ol>
      </div>
      <div class="charge">
        <h3>料金</h3>
        <div v-for="item in priceDate" :key="item.room">
          <p class="room" v-for="(txt, i) in item.room" :key="i">{{ txt }}</p>
          <div class="price">
            {{ item.stay }}&#12288;&yen;<b>{{ item.price }}</b>
          </div>
          <div v-if="!(item.people === '')" class="people">
            <br />
            <span class="people">
              {{ item.people }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image01: String,
    image02: String,
    image03: String,
    area: String,
    name: String,
    subName: String,
    puroductNo: String,
    catchTxt: Array,
    privilege: Array,
    priceDate: Array,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/molecules/halfPlan/hotelPlan.scss";
</style>
